var label = 'nwep030';
var primary = 'nwep031 nwep030';
var secondary = 'nwep032 nwep030';

export { label, primary, secondary };
//# sourceMappingURL=label.css.js.map
